define(['./GoogleAnalyticsAdapter'], (googleAnalyticsAdapter) => {
    const configuration = {
        cookieDomain: 'auto'
    };

    const plugins = [];

    return {
        configure(config) {
            Object.assign(configuration, config);
            return this;
        },

        enablePlugin(pluginName) {
            plugins.push(pluginName);
            return this;
        },

        $get: [
            'googleAnalytics',
            ga => {
                return googleAnalyticsAdapter(
                    ga, configuration, plugins
                );
            }
        ]
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/adapters/googleAnalyticsAdapterProvider.js